import React from 'react'

import { Formik } from 'formik'

import { ZariContext } from '_zari/context'
import { Modal, Form, Button } from '_zari/core'

import * as FormGroups from './formGroups'

import * as EsquemaBalanceGeneralService from 'services/esquemaBalanceGeneral.service'

const InsertarActualizarModal = ({ show, handleClose, nodoPadreData, editarData, reloadTree }) => {
  const __zariContext = React.useContext(ZariContext)

  const formInitialValues = React.useMemo(() => {
    let nivel = 1
    if (nodoPadreData.nivel) {
      nivel = nodoPadreData.nivel + 1
    }

    let _idNodoPadre = null
    if (nodoPadreData._id) {
      _idNodoPadre = nodoPadreData._id
    }

    return {
      _idNodoPadre: _idNodoPadre,
      nivel: nivel,
      codigo: editarData.codigo ?? '',
      nombre: editarData.nombre ?? ''
    }
  }, [editarData, nodoPadreData])

  const onSubmit = React.useCallback(
    (data, { setSubmitting }) => {
      const funcionSubmit = editarData._id
        ? () => EsquemaBalanceGeneralService.actualizarxId(editarData._id, data)
        : () => EsquemaBalanceGeneralService.nuevo(data)

      funcionSubmit()
        .then(() => {
          __zariContext.snack('success', 'El registro se ha guardado.')
          reloadTree()
          handleClose()
        })
        .catch(({ data: { error } }) => {
          __zariContext.snack('error', error)
          setSubmitting(false)
        })
    },
    [__zariContext, editarData, reloadTree, handleClose]
  )

  return (
    <Modal show={show} size='sm'>
      <Modal.Header>
        <Modal.Title>{editarData._id ? 'Actualizar Item' : 'Nuevo Item'}</Modal.Title>
      </Modal.Header>
      <Formik initialValues={formInitialValues} onSubmit={onSubmit}>
        {({ errors, touched, values, isSubmitting, handleSubmit }) => (
          <>
            <Modal.Body>
              <Form>
                {values.nivel === 3 && (
                  <FormGroups.CodigoFormGroup
                    fIsSubmitting={isSubmitting}
                    iError={errors.codigo}
                    iTouched={touched.codigo}
                  />
                )}
                <FormGroups.NombreFormGroup
                  fIsSubmitting={isSubmitting}
                  iError={errors.nombre}
                  iTouched={touched.nombre}
                />
              </Form>
            </Modal.Body>
            <Modal.Footer>
              <Button outline tiny color='secondary' onClick={handleClose}>
                Cancelar
              </Button>
              <Button tiny disabled={isSubmitting} onClick={handleSubmit}>
                Guardar
              </Button>
            </Modal.Footer>
          </>
        )}
      </Formik>
    </Modal>
  )
}

export default React.memo(InsertarActualizarModal)
